import { get, groupBy, map } from 'lodash';

import Product from 'models/Product';
import UpsellMasterProduct from 'models/UpsellMasterProduct';

const UpsellsSelector = class {
  static getUpsellMasterProducts = state => {
    const productKeys = get(state, ['upsells', 'data', 'productsSortOrder']);
    const productData = get(state, ['upsells', 'data', 'products']);

    const colors = map(productKeys, key => new Product(get(productData, key)));

    const colorsGroupedByMaster = groupBy(colors, 'masterId');

    const upsellMasterProducts = map(
      colorsGroupedByMaster,
      groupedColors => new UpsellMasterProduct(groupedColors)
    );

    return upsellMasterProducts;
  };
};
export default UpsellsSelector;
